import XLSX from 'xlsx-js-style'

export const exportToExcel = (filteredTrips, columnConfig) => {
  const wb = XLSX.utils.book_new()
  const dataToExport = filteredTrips.map((travel) => {
    const rowData = {}
    columnConfig.forEach((column) => {
      if (column.key === 'user_data') {
        const user_name =
          travel.user_data && travel.user_data.name ? travel.user_data.name : ''
        const user_lastName =
          travel.user_data && travel.user_data.last_name
            ? travel.user_data.last_name
            : ''
        rowData[column.label] = `${user_name} ${user_lastName}`
      } else if (column.key === 'locations[0].description') {
        const originDescription =
          travel.locations && travel.locations.length > 0
            ? travel.locations[0].description
            : 'N/A'
        rowData[column.label] = originDescription
      } else if (column.key === 'locations[1].description') {
        const destinoDescription =
          travel.locations && travel.locations.length > 0
            ? travel.locations[1].description
            : 'N/A'
        rowData[column.label] = destinoDescription
      } else if (
        column.key === 'time_request' &&
        typeof travel[column.key] === 'number'
      ) {
        const date = new Date(travel[column.key])
        rowData[column.label] = date.toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
        })
      } else if (column.key === 'driver_name') {
        const driverName = travel.driver_data
          ? `${travel.driver_data.name} ${travel.driver_data.last_name}`
          : 'N/A'
        rowData[column.label] = driverName
      } else {
        rowData[column.label] = travel[column.key] || 'N/A'
      }
    })
    return rowData
  })

  const ws = XLSX.utils.json_to_sheet(dataToExport)
  ws['!charset'] = 'UTF-8'
  XLSX.utils.book_append_sheet(wb, ws, 'Viajes Finalizados')

  const columnWidths = []
  columnConfig.forEach((column, columnIndex) => {
    const minWidth = 20
    let maxWidth = minWidth

    dataToExport.forEach((rowData) => {
      const cellValue = rowData[column.label] || ''
      const cellWidth = cellValue.toString().length + 2
      if (cellWidth > maxWidth) {
        maxWidth = cellWidth
      }
    })

    if (maxWidth < minWidth) {
      maxWidth = minWidth
    }

    columnWidths[columnIndex] = { width: maxWidth }
  })

  ws['!cols'] = columnWidths
  XLSX.writeFile(wb, 'Viajes Finalizados.xlsx')
}
